import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    isAuthLoaded: false,
    token: localStorage.getItem('strapi_jwt') || null,
    bookings: [],
    search: '',
    events: [],
    notifications:[],
    selectedCanal: { "id": 1, "attributes": { "title": "Wall" } },
    wallCanals: []
  },
  getters: {
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_AUTH_LOADED(state, status) {
      state.isAuthLoaded = status
    },
    SET_TOKEN(state, token) {
      localStorage.setItem('strapi_jwt', token)
      sessionStorage.setItem('jwt_backup', token);
      state.token = token
    },
    updateDeviceToken(state, newToken) {
      state.user.device_token = newToken;
    },
    SET_BOOKINGS(state, bookings) {
      state.bookings = bookings
    },
    SET_SEARCH(state, search) {
      state.search = search
    },
    SET_EVENTS(state, events) {
      state.events = events
    },
    SET_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications
    },
    SET_SELECTED_CANAL(state, canal) {
      state.selectedCanal = canal
    },
    SET_WALL_CANALS(state, canals) {
      state.wallCanals = canals
    }
  },
  actions: {
    async loadFullUser({ commit }, userId) {
      try {
        const response = await this._vm.$strapi.findOne('users', userId, {
          populate: {
            users_entreprise: { populate: '*' },
            companies: {
              populate: {
                zones: { populate: '*' },
                contract: { populate: '*' }
              }
            },
            avatar: { populate: '*' },
            salle_de_reunions: { populate: '*' }
          }
        });
        commit('SET_USER', response);
        return response;
      } catch (error) {
        console.error('Erreur lors du chargement de l\'utilisateur:', error);
        throw error;
      }
    },
    async getCurrentUser({ dispatch }) {
      try {
        const basicUser = await this._vm.$strapi.fetchUser();
        await dispatch('loadFullUser', basicUser.id);
        return basicUser;
      } catch (error) {
        console.error('Erreur lors de la récupération de l\'utilisateur:', error);
        throw error;
      }
    },
    setUser({ commit }, user) {
      commit('SET_USER', user)
    },
    setAuthLoaded({ commit }, status) {
      commit('SET_AUTH_LOADED', status)
    },
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    setBookings({ commit }, bookings) {
      commit('SET_BOOKINGS', bookings)
    },
    setSearch({ commit }, search) {
      commit('SET_SEARCH', search)
    },
    setEvents({ commit }, events) {
      commit('SET_EVENTS', events)
    },
    setNotifications({ commit }, notifications) {
      commit('SET_NOTIFICATIONS', notifications)
    },
    setSelectedCanal({ commit }, canal) {
      commit('SET_SELECTED_CANAL', canal)
    },
    setWallCanals({ commit }, canals) {
      commit('SET_WALL_CANALS', canals)
    }
  },
  modules: {
  }
})
